import { render, staticRenderFns } from "./two-pop-chats.vue?vue&type=template&id=f94ef344&"
import script from "./two-pop-chats.vue?vue&type=script&lang=js&"
export * from "./two-pop-chats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f94ef344')) {
      api.createRecord('f94ef344', component.options)
    } else {
      api.reload('f94ef344', component.options)
    }
    module.hot.accept("./two-pop-chats.vue?vue&type=template&id=f94ef344&", function () {
      api.rerender('f94ef344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/two-pop-chats.vue"
export default component.exports